<template>
  <div class="d-flex flex-column h-100">
    <b-modal
      size="lg"
      id="editMembershipModal"
      ref="editMembershipModal"
      hide-footer
    >
      <template #modal-title>Manage Membership</template>

      <edit-membership
        :membership="membership"
        @complete="editMembershipComplete"
        v-if="membership"
      ></edit-membership>
    </b-modal>
    <card class="member-cards">
      <b-row class="pb-5">
        <b-col>
          <b-button variant="primary" @click="newMembership"
            >New Membership</b-button
          >
        </b-col>
        <b-col class="text-right">
          <b-form-checkbox @change="activeChanged" switch v-model="isActive"
            >Active</b-form-checkbox
          >
        </b-col>
      </b-row>
      <b-row class="d-flex h-100">
        <b-col
          sm="12"
          xs="12"
          md="6"
          lg="6"
          xl="4"
          v-for="membership in memberships"
          :key="membership.id"
          class="d-flex flex-column"
        >
          <membership-item
            :membership="membership"
            @editMembership="editMembership"
          ></membership-item>
        </b-col>
      </b-row>
    </card>
  </div>
</template>

<script>
import MembershipItem from "@/views/Components/Membership/MembershipItem";
import EditMembership from "@/views/Components/Membership/EditMembership";
export default {
  components: { MembershipItem, EditMembership },
  title: "Memberships",
  methods: {
    async endDrag(e) {
      var self = this;
      var sortList = self.memberships.map((e, index) => {
        return { id: e.id, index: index };
      });

      var r = await self.$client.post("/api/membership/sort", {
        items: sortList,
      });
    },

    activeChanged() {
      var self = this;
      self.bind();
    },
    editMembershipComplete() {
      var self = this;
      self.bind();
      self.$refs.editMembershipModal.hide();
    },
    newMembership() {
      var self = this;
      self.membership = {
        id: null,
        cycle: "YEARLY",
        imageId: "girl_teen.jpg",
        monthlyAmount: 0,
        yearlyAmount: 0,
        isActive: true,
        membershipBenefits: [],
      };
      self.$refs.editMembershipModal.show();
    },
    editMembership(membership) {
      var self = this;
      self.membership = membership;
      self.$refs.editMembershipModal.show();
    },
    async bind() {
      var self = this;
      var r = await self.$client.get(
        "/api/membership/getMemberships?isActive=" + self.isActive
      );
      self.memberships = r.data.value;
    },
  },
  mounted() {
    var self = this;
    self.bind();
  },
  data() {
    return {
      membership: null,
      isActive: true,
      memberships: [],
    };
  },
};
</script>

<style>
.member-cards > .card-body {
  padding-bottom: 10px;
}
</style>
